import React from 'react';
import BookKidle from '../../assets/img/img-book-kidle.png';
import './Publish.css';

export default class Publish extends React.Component {

    handleClickPushAllBooks(path){
        const { history } = this.props;
        history.push(path);
     }


    render() {
        return (
            <div id="Publish" className="issue" >
                <div className="container publish">
                    <h3 className="title-publish color-default">PUBLIQUE</h3>
                    <h4 className="title-publish-2" style={{ fontSize: '27px' }}>Do papel ao digital, pensamos nos minimos detalhes</h4>
                    <div className="row">
                        <div className="col-12 col-md-12 col-lg-6 col-xl-6">
                            <p className="content-text">
                                Em um mundo tão conectado onde a informação circula de forma dinâmica e
                                veloz temos a missão de publicar seu livro com foco em qualidade editorial e
                                gráfica, cumprimento dos prazos estipulados no decorrer da edição e preços
                                especiais para o autor.

                            </p>
                            <p className="text-color content-text">Nossos prazos são estipulados após análise da complexidade dos arquivos a
                            ser editados.
                            </p>
                            <h5 className="list-title text-color">As etapas são: </h5>

                            <ol className="text-color">
                                <li className="list-item" > <strong className="list-item-number" >1. </strong> Cadastro do autor(a) e livro;</li>
                                <li className="list-item" > <strong className="list-item-number" >2. </strong> Contato da editora para saber mais detalhes;</li>
                                <li className="list-item" > <strong className="list-item-number" >3. </strong> Envio dos arquivos para inicio da edição;</li>
                                <li className="list-item" > <strong className="list-item-number" >4. </strong> Revisão ortográfica e gramatical;</li>
                                <li className="list-item" > <strong className="list-item-number" >5. </strong> Projeto, diagramação e capa;</li>
                                <li className="list-item" > <strong className="list-item-number" >6. </strong> Leitura pelo autor(a) e nosso revisor do livro editado;</li>
                                <li className="list-item" > <strong className="list-item-number" >7. </strong> Aprovação e escolha do autor da sua tiragem;</li>
                                <li className="list-item" > <strong className="list-item-number" >8. </strong> Produção e entrega.</li>
                            </ol>
                        </div>
                        <div className="col-12 col-md-12 col-lg-6 col-xl-6 kindle-container">
                            <figure className="img-container">
                                <img className="img-book" src={BookKidle} alt="" />
                            </figure>
                        </div>
                    </div>
                    <div className="buttons-publish">
                        <button
                            className="button-publish"
                            onClick={() => this.handleClickPushAllBooks('/CadastrarAutor')}>
                                CADASTRAR AUTOR
                        </button>
                        <button
                            className="button-publish yellow"
                            onClick={() => this.handleClickPushAllBooks('/CadastrarLivro')}>
                            CADASTRAR LIVRO
                        </button>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Publish/Publish.js